import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import ItemShorthandMain from "./ItemShorthandMain";
import DocAttribute from "../../../cmn/docAttribute/DocAttribute";
import FormTitle from '../../../../library/form/components/FormTitle'
import FormDialog from '../../../../library/form/components/FormDialog';
import useViewSwitcher from '../../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../../library/hooks/switch/SarasViewSwitch'
import SarasTabsSwitch from '../../../../library/repeater/tabs/SarasTabsSwitch'
import { UiView, UiForm, UiGroupHeader, UiGroupContent } from "../../../../library/layout/Index";

const itemSwitches = [
    { key: "header", val: "General", isDefault: 1 },
    { key: "group", val: "Group Info", showKey:"itemGroupInfo" },
    { key: "attr", val: "Attribute", showKey:"itemAttrInfo" }
]

const ItemShorthand = (props) => {
    const { formObject, viewMap, viewData, ...restProps } = props;
    const [formAction, setFormAction] = React.useState({});

    const viewSwitcher = useViewSwitcher("header");

    const showKeysData = formObject.getFormRow("", "showViewKeys");
    const showKeys = showKeysData? showKeysData.RowValuesKeys: [];
    
    const closeModel = () => {
        setFormAction({});
        restProps.onDynamicViewClose();
    }

    const onCancelClick = () => {
        setFormAction({action:'Cancel', counter: (formAction.counter || 0) + 1});
    }

    const onSaveClick = () => {
        setFormAction({action:'Save', counter: (formAction.counter || 0) + 1});
    }

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            contentStyle={{ height: '450px' }}
            action={{ formActions: { forAction: "Confirm", actionFunction: onSaveClick, cancelFunction: onCancelClick, forCancel: "Cancel" }, actionParam:{showModeID:"sh" } }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Item" />}
            >
            <UiView>
                <UiGroupHeader>
                    <SarasTabsSwitch viewSwitcher={viewSwitcher} switches={itemSwitches} showKeys={showKeys}/>
                </UiGroupHeader>
                <UiGroupContent>
                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='header' hideMode='soft' >
                        <UiForm formName="Shorthand">
                            <ItemShorthandMain viewMap={viewMap} closeModel={closeModel} formAction={formAction} viewData={viewData.childViews.itemShorthand} />
                        </UiForm>
                    </SarasViewSwitch>

                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='group' hideMode='soft' >
                        <UiForm formName="Group">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.itemGroupInfo} />
                        </UiForm>
                    </SarasViewSwitch>

                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='attr' hideMode='soft' >
                        <UiForm formName="Attr">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.itemAttrInfo} />
                        </UiForm>
                    </SarasViewSwitch>
                </UiGroupContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(ItemShorthand, "itemComp");
